var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "task-child-upload" }, [
    _c("div", { staticClass: "task-child-upload-l" }, [
      _c("img", {
        staticClass: "task-child-upload-l-icon",
        attrs: { src: require(`@/icons/svg/${_vm.info.icon}.svg`), alt: "" },
      }),
      _vm.info.status === "pause"
        ? _c("div", { staticClass: "task-child-upload-l-stop" }, [
            _c("img", {
              attrs: { src: require("@/icons/svg/t_suspend.svg"), alt: "" },
            }),
          ])
        : _vm._e(),
    ]),
    _c("div", { staticClass: "task-child-upload-r" }, [
      _c("div", { staticClass: "task-child-upload-r-info" }, [
        _c("div", { staticClass: "task-child-upload-r-info-title" }, [
          _vm._v(_vm._s(_vm.info.filename)),
        ]),
        _c("div", { staticClass: "task-child-upload-r-info-status" }, [
          _vm._v(_vm._s(_vm.info.origin)),
        ]),
      ]),
      _vm.info.status === "uploading" || _vm.info.status === "pause"
        ? _c(
            "div",
            { staticClass: "m-t-8" },
            [
              _c("el-progress", {
                attrs: {
                  "stroke-width": 6,
                  percentage: _vm.progress,
                  format: _vm.progressFormat,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c("div", { staticClass: "task-child-upload-r-upload-msg" }, [
        _c(
          "div",
          { staticClass: "task-child-upload-r-upload-msg-l" },
          [
            _c("div", [_vm._v(_vm._s(_vm._f("getFileSize")(_vm.info.size)))]),
            [
              _vm.info.status === "parsing-wait"
                ? _c("div", { staticClass: "m-l-16" }, [_vm._v(" 等待中… ")])
                : _vm._e(),
              _vm.info.status === "parsing"
                ? _c("div", { staticClass: "task-color-orange m-l-16" }, [
                    _vm._v(" 解析中 "),
                  ])
                : _vm.info.status === "uploading"
                ? _c("div", { staticClass: "m-l-16" }, [_vm._v(" 上传中 ")])
                : _vm.info.status === "wait"
                ? _c("div", { staticClass: "m-l-16" }, [_vm._v("等待中…")])
                : _vm.info.status === "pause"
                ? _c("div", { staticClass: "m-l-16" }, [_vm._v("暂停中")])
                : _vm.info.status === "fail"
                ? _c(
                    "div",
                    { staticClass: "task-color-red m-l-16" },
                    [
                      _c("span", { staticStyle: { "margin-right": "4px" } }, [
                        _vm._v("上传失败"),
                      ]),
                      _c(
                        "el-popover",
                        {
                          attrs: {
                            placement: "bottom",
                            width: "268",
                            trigger: "hover",
                          },
                        },
                        [
                          _c("span", { staticClass: "errorReason" }, [
                            _vm._v(_vm._s(_vm.info.errorReason)),
                          ]),
                          _c("img", {
                            staticStyle: {
                              "font-size": "16px",
                              "margin-top": "1px",
                            },
                            attrs: {
                              slot: "reference",
                              src: require("@/icons/svg/questionRed.svg"),
                              alt: "",
                            },
                            slot: "reference",
                          }),
                        ]
                      ),
                    ],
                    1
                  )
                : _vm.info.status === "success"
                ? _c("div", { staticClass: "task-color-green m-l-16" }, [
                    _vm._v(" 上传成功 "),
                  ])
                : _vm._e(),
              _vm.info.status === "uploading" || _vm.info.status === "pause"
                ? _c("div", { staticClass: "m-l-5" }, [
                    _vm._v(" " + _vm._s(_vm.progress) + "% "),
                  ])
                : _vm._e(),
            ],
          ],
          2
        ),
        _c(
          "div",
          [
            _vm.info.status === "pause"
              ? _c(
                  "el-button",
                  {
                    staticClass: "task-child-upload-r-upload-msg-r-action",
                    attrs: { type: "text", loading: _vm.info.loading },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.debounceMethods(_vm.handleClickReload)
                      },
                    },
                  },
                  [_vm._v("继续上传")]
                )
              : _vm._e(),
            _vm.info.status === "uploading"
              ? _c(
                  "el-button",
                  {
                    staticClass: "task-child-upload-r-upload-msg-r-action",
                    attrs: { type: "text", loading: _vm.info.loading },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.debounceMethods(_vm.handleClickPause)
                      },
                    },
                  },
                  [_vm._v("暂停上传")]
                )
              : _vm._e(),
            _vm.info.status !== "uploading" && _vm.info.status !== "parsing"
              ? _c(
                  "el-button",
                  {
                    staticClass: "task-child-upload-r-upload-msg-r-action-del",
                    attrs: { loading: _vm.info.loading, type: "text" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.delUploadFile.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("删除")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }